import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import { useMemo, useEffect } from 'react';
import { WebGLMultisampleRenderTarget, WebGLRenderTarget } from 'three';
import { useThree } from 'react-three-fiber';

// 👇 uncomment when TS version supports function overloads
// export function useFBO(settings?: FBOSettings)
function useFBO(width, height, settings) {
  const {
    size,
    gl
  } = useThree();
  const dpr = useMemo(() => gl.getPixelRatio(), [gl]);

  const _width = typeof width === 'number' ? width : size.width * dpr;

  const _height = typeof height === 'number' ? height : size.height * dpr;

  const _settings = (typeof width === 'number' ? settings : width) || {};

  const target = useMemo(() => {
    const {
      multisample,
      samples
    } = _settings,
          targetSettings = _objectWithoutPropertiesLoose(_settings, ["multisample", "samples"]);

    let target;

    if (multisample && gl.capabilities.isWebGL2) {
      target = new WebGLMultisampleRenderTarget(_width, _height, targetSettings);
      if (samples) target.samples = samples;
    } else {
      target = new WebGLRenderTarget(_width, _height, targetSettings);
    }

    return target; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    target.setSize(_width, _height);
  }, [target, _width, _height]);
  useEffect(() => {
    return () => target.dispose(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return target;
}

export { useFBO };
